import CloseButton from 'components/Overlay/CloseButton';
import React, { useContext } from 'react';
import { CartContext } from 'constants/contexts';
import { Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import useMerchantPath from 'hooks/useMerchantPath';

function Header({ handleCloseCart }) {
  const { merchant, items } = useContext(CartContext);
  const merchantPath = useMerchantPath(merchant);
  if (!merchant || items.length === 0) {
    return 'Cart';
  }
  return (
    <Stack height={64}>
      <Stack direction="row" alignItems="center">
        <CloseButton />
        <Typography variant="title-md">Cart</Typography>
      </Stack>

      <Typography
        variant="body-caption"
        display="block"
        component={Link}
        onClick={handleCloseCart}
        to={merchantPath}
        color="text.primary"
        mt={-1}
        ml={5.5}
      >
        Order from
        {' '}
        {merchant.name}
      </Typography>
    </Stack>
  );
}

export default Header;
